"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = trackLink;
const link_1 = __importDefault(require("~/helpers/link"));
const usermodel_1 = __importDefault(require("~/models/usermodel"));
let userInfo;
usermodel_1.default.load().then((i) => {
    userInfo = i;
});
function trackLink(event, id) {
    var _a, _b;
    const el = link_1.default.validUrlClick(event);
    const isResource = ((_a = el.dataset) === null || _a === void 0 ? void 0 : _a.variant) === 'resource';
    const trackThis = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.accounts_id) &&
        ((_b = el === null || el === void 0 ? void 0 : el.dataset) === null || _b === void 0 ? void 0 : _b.track) &&
        id;
    if (trackThis) {
        /* eslint-disable camelcase */
        event.trackingInfo = {
            book: id,
            account_uuid: userInfo.uuid,
            [isResource ? 'resource_name' : 'book_format']: el.dataset.track,
            contact_id: userInfo === null || userInfo === void 0 ? void 0 : userInfo.salesforce_contact_id
        };
        /* eslint-enable camelcase */
    }
}
